import { defineComponent, withKeys } from 'vue';
import { IGetCanalErrorLogsRes } from '@/api/goods-service/type.d';
import { useList } from '@/hooks/use-list';
import { getCanalErrorLogs, syncCanalErrorLog } from '@/api/goods-service/index';
import { GOODS_SERVICE_ERROR_LOG_STATE_LIST } from '@/constant';
import { IParams } from './type.d';
import { ElMessage } from 'element-plus';
import { formatTime } from '@toy/utils';
import CustomTable from '@/components/custom-table/index';
import { renderColumns } from './tableData';
import usePermissionConfig from './use-permission-config';

export default defineComponent({
  components: {
    CustomTable,
  },
  setup() {
    const {
      params,
      tableTotal,
      tableData,
      tableLoading,
      handleSearch,
      handleReset,
      handleSizeChange,
      handleCurrentChange,
    } = useList<IGetCanalErrorLogsRes, IParams>({
      request: {
        api: getCanalErrorLogs,
        params: {
          date: [],
          handledState: '',
          pageNum: 1,
          pageSize: 10,
        },
        handleParams(paramsObj) {
          if (paramsObj.handledState === '') {
            delete paramsObj.handledState;
          }
          if (paramsObj.date?.length) {
            const [createStart, createEnd] = paramsObj.date;
            paramsObj.createStart = formatTime(createStart);
            paramsObj.createEnd = formatTime(createEnd);
          }
          delete paramsObj.date;
          return paramsObj;
        },
      },
    });
    const handleSyncItem = async (logId: string) => {
      try {
        await syncCanalErrorLog({
          logId,
        });
        ElMessage.success('已发起同步请求');
        handleSearch(params.value.pageNum);
      } catch (error) {
        console.log('同步失败', error);
      }
    };

    const permissionConfig = usePermissionConfig();

    return {
      handleSyncItem,
      params,
      tableTotal,
      tableData,
      tableLoading,
      handleSearch,
      handleReset,
      handleSizeChange,
      handleCurrentChange,
      GOODS_SERVICE_ERROR_LOG_STATE_LIST,
      permissionConfig,
    };
  },
  render() {
    const slots = {
      fheader: () => (
        <el-form
          class="fixed-el-form-item-height"
          size="default"
          onKeyup={withKeys(() => this.handleSearch(), ['enter'])}
        >
          <el-form-item label="处理状态" label-width="70px">
            <el-select v-model={this.params.handledState} clearable>
              {GOODS_SERVICE_ERROR_LOG_STATE_LIST.map(item => (
                <el-option value={item.value} label={item.label} key={item.value} />
              ))}
            </el-select>
          </el-form-item>
          <el-form-item label="创建时间" label-width="80px">
            <el-date-picker
              v-model={this.params.date}
              type="datetimerange"
              format="YYYY-MM-DD HH:mm:ss"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            />
          </el-form-item>
          <el-form-item label-width="0" class="margin-left-20">
            <el-button type="primary" size="default" onClick={() => this.handleSearch()}>
              查询
            </el-button>
            <el-button size="default" onClick={this.handleReset}>
              重置
            </el-button>
          </el-form-item>
        </el-form>
      ),
      main: ({ height }: any) => (
        <custom-table
          size="medium"
          data={this.tableData}
          columns={renderColumns(
            this.handleSyncItem,
            this.$filters,
            this.$has(this.permissionConfig.SYNC),
          )}
          height={height}
          key={height}
          v-loading={this.tableLoading}
        />
      ),
      ffooter: () => (
        <el-row style="width: 100%;padding-top:10px" type="flex" justify="end">
          <pagination
            total={this.tableTotal}
            current-page={this.params.pageNum}
            size={this.params.pageSize}
            onCurrentChange={this.handleCurrentChange}
            onSizeChange={this.handleSizeChange}
            page-sizes={[10, 20, 30, 50, 100, 200]}
          ></pagination>
        </el-row>
      ),
    };
    return (
      <div class="error-logs">
        <app-page v-slots={slots} />
      </div>
    );
  },
});
